export const en = {
    need_help: 'Need help?',
    contact_support_with_any_questions: 'Contact support with any questions about the process of making a business trip',
    ask_question: 'Ask a question',
};
